import { taktileInternalPrefix } from "src/api/constants";

export interface StringConstraints {
  readonly allowedCharacters: RegExp;
  readonly minLength: number;
  readonly maxLength: number;
}

export const getStringValidations = (constraints: StringConstraints) => ({
  noLeadingTrailingSpaces: (value: string) => value === value.trim(),
  lengthRestriction: (value: string) =>
    value.length >= constraints.minLength &&
    value.length <= constraints.maxLength,
  disallowedCharacters: (value: string) =>
    constraints.allowedCharacters.test(value),
});

export const SLUG_ALLOWED_CHARACTERS = /^[A-Za-z0-9-]*$/;

export const WORKSPACE_SLUG_CONSTRAINTS: StringConstraints = {
  allowedCharacters: SLUG_ALLOWED_CHARACTERS,
  minLength: 4,
  // Workspace slugs must be shorter since they are part of the DNS name
  maxLength: 20,
};

export const FLOW_SLUG_CONSTRAINTS: StringConstraints = {
  allowedCharacters: SLUG_ALLOWED_CHARACTERS,
  minLength: 4,
  maxLength: 80,
};

export const getWorkspaceSlugErrorMessage = (type: string): string => {
  const { minLength, maxLength } = WORKSPACE_SLUG_CONSTRAINTS;
  switch (type) {
    case "required":
      return "This field cannot be empty";
    case "noLeadingTrailingSpaces":
      return "This value cannot have leading or trailing spaces";
    case "lengthRestriction":
      return `This value has to be between ${minLength} and ${maxLength} characters long`;
    case "disallowedCharacters":
      return "This value is not valid. Please only use letters, digits and dashes.";
    case "notAvailable":
      return "This value is already in use";
    case "noInternalPrefix":
      return `This value cannot start with ${taktileInternalPrefix}`;
    default:
      return "";
  }
};

export const getFlowSlugErrorMessage = (type: string): string => {
  const { minLength, maxLength } = FLOW_SLUG_CONSTRAINTS;
  switch (type) {
    case "required":
      return "URL Identifier cannot be empty";
    case "noLeadingTrailingSpaces":
      return "URL Identifier cannot have leading or trailing spaces";
    case "lengthRestriction":
      return `URL Identifier has to be between ${minLength} and ${maxLength} characters long`;
    case "disallowedCharacters":
      return "URL Identifier is not valid. Please only use letters, digits and dashes.";
    case "notAvailable":
      return "URL Identifier is already in use";
    case "noInternalPrefix":
      return `URL Identifier cannot start with ${taktileInternalPrefix}`;
    default:
      return "";
  }
};
